import DexieDB from 'dexie';

export const db = new DexieDB('MyDB');

db.version(1).stores({
  files: 'id',
});

export const saveFile = async (file) => {
  await db.files.put(file);
};

export const deleteFile = async (id) => {
  console.log(db.files.toArray());
  await db.files.delete(id);
};

export const deleteFileFromDb = async (id) => {
  console.log(db.files.toArray());
  await db.files.delete(id);
};

export const updateFile = async (id, updates) => {
  await db.files.update(id, updates);
};

export const findFile = async (id) => {
  return db.files.get(id);
};

export const clearFiles = async () => {
  await db.files.clear();
};
